<template>
  <div class="fixed top-24 right-4 z-[10000] space-y-2">
    <TransitionGroup name="notification">
      <default-ui-notification-item
        v-for="notif in notifications"
        :key="notif.id"
        :type="notif.type"
        @close="notification.remove(notif.id)"
      >
        <p v-html="textMsg2html(notif.message)"></p>
      </default-ui-notification-item>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
const { notifications, notification } = useNotifications()

const textMsg2html = (msg: String) => (msg || '').replace(/\n/g, '<br>')
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: all 0.5s ease;
}
.notification-enter-from,
.notification-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>